import { render, staticRenderFns } from "./CRMMessage.vue?vue&type=template&id=300b70c0&scoped=true"
import script from "./CRMMessage.vue?vue&type=script&lang=js"
export * from "./CRMMessage.vue?vue&type=script&lang=js"
import style0 from "./CRMMessage.vue?vue&type=style&index=0&id=300b70c0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b70c0",
  null
  
)

export default component.exports